var map = {
	"./a11y-labels.json": 582,
	"./art-prize/2019.json": 583,
	"./art-prize/2020.json": 584,
	"./art-prize/global.json": 585,
	"./auth.json": 586,
	"./beginners-series.json": 587,
	"./beta-eoi.json": 588,
	"./careers-position.json": 589,
	"./careers.json": 590,
	"./dreams.json": 591,
	"./faq.json": 592,
	"./footer.json": 593,
	"./global.json": 594,
	"./handbook.json": 595,
	"./home.json": 596,
	"./insight.json": 597,
	"./ipad-3d.json": 598,
	"./ipad-a11y.json": 599,
	"./ipad-brushes.json": 600,
	"./ipad-color.json": 601,
	"./ipad-superpowers.json": 602,
	"./ipad-video.json": 603,
	"./ipad-whats-new.json": 604,
	"./ipad.json": 605,
	"./meta.json": 606,
	"./navigation.json": 607,
	"./navigation/connect.json": 608,
	"./navigation/dreams.json": 609,
	"./navigation/explore.json": 610,
	"./navigation/folio.json": 611,
	"./navigation/footer.json": 612,
	"./navigation/labels.json": 613,
	"./navigation/pocket.json": 614,
	"./navigation/procreate.json": 615,
	"./navigation/sections.json": 616,
	"./navigation/support.json": 617,
	"./pocket-whats-new.json": 618,
	"./pocket.json": 619,
	"./press.json": 620,
	"./prize.json": 621,
	"./sitemap.json": 622,
	"./special-event.json": 623,
	"./support.json": 624
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 581;